import { Grid } from "@mui/material"
import { TCLabel } from "./Label/TopCourtLabel";

function CourtLogo({
    place,
    logoOnly = false,
    width = 13,
    height = 13,
    isSubtitle = false
}) {
    const merchantCandidates = [
        place,
        place?.placeId,
        place?.placeDetail,
        place?.place,
        place?.merchantId,
        place?.court?.placeId,
    ];

    const merchant = merchantCandidates.find((item) => item?.logo) || null;
    console.log(place, merchant)
    return (
        <div container alignItems="center" style={{
            marginTop: 1,
            display: 'flex'
        }}>
            <img
                alt={merchant?.name || 'court logo'}
                style={{ marginRight: 3, marginBottom: 2, objectFit: 'fill', display: 'block' }}
                src={merchant?.logo}
                width={width} height={height}
            />
            {
                !logoOnly && <TCLabel subtitle={isSubtitle} style={{ fontSize: 12 }}>{merchant?.name}</TCLabel>
            }
        </div>
    )
}

export { CourtLogo }